module.exports = __webpack_public_path__ + "static/media/tvshows-originals-icon.a85da490.svg";